export const sidebarRoutes: { [route: string]: string } = {
  "/m2c-dashboard": "1",
  "/m2c-golf-history": "2",
  "/pg-history": "17",
  "/m2c-golf-stats": "3",
  "/launch-dashboard": "4",
  "/m2c-launch-stats": "5",
  "/m2c-launch-history": "6",
  "/athletics-dashboard": "7",
  "/m2c-athletics-stats": "8",
  "/m2c-athletics-history": "9",
  "/simulation-dashboard": "13",
  "/simulation-history": "14",
  "/internal-dashboard": "15",
  "/m2c-analytics": "16",
  "/benchmark-history": "21",
  "/m2c-analytics-statistics": "19",
  "/m2c-analytics-tickets": "20",
  "/m2c-studio-dashboard": "22",
};

export const sideBarRoutesObjectBasedOnKeys: {
  [key: string]: { [route: string]: string };
} = {
  1: {
    baseRoute: "/m2c-dashboard",
    sourceDashboard: "m2c",
  },
  2: {
    baseRoute: "/m2c-golf-history",
    sourceDashboard: "m2c",
  },
  3: {
    baseRoute: "/m2c-golf-stats",
    sourceDashboard: "m2c",
  },
  4: {
    baseRoute: "/launch-dashboard",
    sourceDashboard: "launch",
  },
  5: {
    baseRoute: "/m2c-launch-stats",
    sourceDashboard: "launch",
  },
  6: {
    baseRoute: "/m2c-launch-history",
    sourceDashboard: "launch",
  },
  7: {
    baseRoute: "/athletics-dashboard",
    sourceDashboard: "athletics",
  },
  8: {
    baseRoute: "/m2c-athletics-stats",
    sourceDashboard: "athletics",
  },
  9: {
    baseRoute: "/m2c-athletics-history",
    sourceDashboard: "athletics",
  },
  10: {
    baseRoute: "/m2c-sandbox-dashboard",
    sourceDashboard: "sandbox",
  },
  11: {
    baseRoute: "/m2c-sandbox-stats",
    sourceDashboard: "sandbox",
  },
  12: {
    baseRoute: "/m2c-sandbox-history",
    sourceDashboard: "sandbox",
  },

  13: {
    baseRoute: "/simulation-dashboard",
    sourceDashboard: "simulation",
  },
  14: {
    baseRoute: "/simulation-history",
    sourceDashboard: "simulation",
  },
  15: {
    baseRoute: "/internal-dashboard",
    sourceDashboard: "analytics",
  },
  16: {
    baseRoute: "/m2c-analytics",
    sourceDashboard: "analytics",
  },
  17: {
    baseRoute: "/pg-history",
    sourceDashboard: "dashboard",
  },
  19: {
    baseRoute: "/m2c-analytics-statistics",
    sourceDashboard: "analytics",
  },
  20: {
    baseRoute: "/m2c-analytics-tickets",
    sourceDashboard: "analytics",
  },
  21: {
    baseRoute: "/benchmark-history",
    sourceDashboard: "simulation",
  },
  22: {
    baseRoute: "/m2c-studio-dashboard",
    sourceDashboard: "m2c",
  },
};
